import { call, put, all, takeLatest, select } from "redux-saga/effects";

import { getEarlyRegistrationDetailApi } from "core/http/service/timeKeeping";
import {
  getEarlyRegistrationDetailFailed,
  getEarlyRegistrationDetailStart,
  getEarlyRegistrationDetailSuccess,
} from "../redux/getEarlyRegistrationDetail";
import { toast } from "react-toastify";
import { SCREEN } from "helper/roleChecker/Screens";
import { earlyRegistrationDetailId } from "../redux/selector";
import { setEarlyRegistrationFormInput } from "../redux/earlyRegistation";

function* getEarlyRegistrationDetailWork() {
  const id = yield select(earlyRegistrationDetailId);

  try {
    const res = yield call(getEarlyRegistrationDetailApi, SCREEN.IP_016, id);
    if (res) {
      yield put({
        type: getEarlyRegistrationDetailSuccess.type,
        payload: res,
      });

      yield put({
        type: setEarlyRegistrationFormInput.type,
        payload: {
          ...res,
          files: res?.attachedFiles || [],
          approvals: (res?.approvals || [])?.map((item: any) => ({
            ...item,
            name: item?.approverName,
            value: item?.approverCode,
            label: `${item?.approverName} - ${item?.positionName || ""}`,
          })),
        },
      });
      //   toast.success("Cập nhật đơn thành công!");
    }
  } catch (err: any) {
    yield put({
      type: getEarlyRegistrationDetailFailed.type,
    });
    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetEarlyRegistrationDetail() {
  yield takeLatest(
    getEarlyRegistrationDetailStart.type,
    getEarlyRegistrationDetailWork
  );
}

export default function* getEarlyRegistrationDetailSaga() {
  yield all([watchGetEarlyRegistrationDetail()]);
}
